module.exports = "/_next/static/images/clear-bubble-9cae822674a4ad9a9fc193db8177a661.png";